import PersianSupportNumericTextField from 'Global/Components/UnEditableComponents/PersianSupportNumericTextField/PersianSupportNumericTextField';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React from 'react';

const AddBalanceBox = ({ setAmount }) => {
  const increase_balance_label = FindLangKey(
    'genral-public-label-increase-balance'
  );

  return (
    <React.Fragment>
      <PersianSupportNumericTextField
        label={increase_balance_label}
        onChange={setAmount}
        thousandSeparator
      />
    </React.Fragment>
  );
};

export default AddBalanceBox;
